import { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { api, ApiError } from "@utils/index";
import { useLiffContext } from "@/apps/@components/liff-context";

const AuthGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { liffActions } = useLiffContext();
  const [isBindingChecked, setIsBindingChecked] = useState(false);

	const getProfile = async () => {
		try {
			const res = await api.get("/profile");
			return res?.userProfile;
		} catch (error) {
			throw error.response?.data?.error?.code || new Error("Unknown error");
		}
	};
	
	const checkBindingStatus = async () => {
		try {
			const userProfile = await getProfile();
			if (userProfile) {
				liffActions.setProfile({
					ready: true,
					data: userProfile,
				});
			}

			if (userProfile && location.pathname === "/binding") {
				navigate("/profile");
			}
	
			setIsBindingChecked(true);
		} catch (errorCode) {
			switch (errorCode) {
				case ApiError.USER_NOT_BINDED:
					console.warn("User not bound");
					navigate("/binding");
					break;
				default:
					console.error("Unknown error", errorCode);
					break;
			}
			setIsBindingChecked(true);
		}
	};

  useEffect(() => {
    checkBindingStatus();
  }, []);

  if (!isBindingChecked) {
    return null;
  }

  return <Outlet />;
};

export default AuthGuard;
